export default "__VITE_ASSET__d613fa4a__"